import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import React from 'react'
import { ThemeProvider } from '@/components/layout/ThemeProvider'
import '../styles/globals.css'

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx', { eager: true }) as Record<
      string,
      { default: React.ComponentType }
    >
    const page = pages[`../pages/${name}.tsx`]
    if (!page) throw new Error(`Page not found: ${name}`)
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <React.StrictMode>
        <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
          <App {...props} />
        </ThemeProvider>
      </React.StrictMode>
    )
  },
})
